export default "__VITE_ASSET__CWPGsCVA__"